import { useLocation, useParams } from 'react-router-dom';

import { types } from './definitions';

const useKnowledgeBaseIdFromSlug = (): types.UseKnowledgeBaseIdFromSlugReturn => {
  const { hash } = useLocation();
  const { articleSlug = '', sectionId = '', categoryId = '' } = useParams();

  // only one of these params will be available at any moment
  const contentId = categoryId || sectionId || articleSlug;

  const matches = contentId.match(/^[^-]*/);
  const id = matches?.length ? matches[0] : '';
  const [, cleanHash] = hash ? hash.split('#') : '';

  return {
    id,
    hash: cleanHash,
  };
};

export default useKnowledgeBaseIdFromSlug;
